/**
 * Internal Sales List Component
 * 
 * ⚠️ WARNING: This component displays data from INTERNAL backend endpoints.
 * This page uses Basic Authentication validated by the backend.
 * Access: /_dummy/test_test
 * Backend: /_dummy/test_test (Basic Auth required)
 */

import React, { useEffect } from "react";
import PageHeader from "app/main/shared-components/page-header/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "app/store";
import PaginationBar from "app/main/shared-components/pagination-bar/PaginationBar";
import { useTranslation } from "react-i18next";
import InternalSearchSaleTable from "./InternalSearchSaleTable";
import SaleTable from "./SaleTable";
import { fetchInternalSales } from "app/main/sales/store/internal-sales-list.slice";
import { setInternalSalesFilters } from "app/main/sales/store/internal-filter-sales.slice";
import InternalLoginGate from "./InternalLoginGate";
import { Button } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

const STORAGE_KEY = "internal_basic_auth";

const InternalSalesList: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const filters = useSelector((s: AppState) => s.internalSales.filters);
  const { loading, response, rows } = useSelector(
    (s: AppState) => s.internalSales.list
  );

  const pageSize = response?.reservations?.size || filters.size || 20;
  const totalPages = response?.reservations?.totalPages || 1;
  const currentPageZeroBased = response?.reservations?.number ?? filters.page ?? 0;

  const handleLogout = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    window.location.reload();
  };

  return (
    <InternalLoginGate>
      <div style={{ 
        minHeight: '100vh', 
        height: '100%',
        overflow: 'auto',
        padding: '20px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <PageHeader
            title={t("Internal Sale List", "Internal Sale List")}
            desc={t("Internal Sales Data", "Internal Sales Data")}
          />
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<ExitToAppIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
        <InternalSearchSaleTable />
        <SaleTable rows={rows} loading={loading} response={response} />
        <PaginationBar
          totalPages={totalPages}
          currentPage={currentPageZeroBased + 1}
          onPageChange={(uiPage: number) => {
            const newPage = uiPage;
            dispatch(
              setInternalSalesFilters({ ...filters, page: newPage, size: pageSize })
            );
            dispatch(fetchInternalSales({ ...filters, page: newPage, size: pageSize }));
          }}
        />
      </div>
    </InternalLoginGate>
  );
};

export default InternalSalesList;
